import React, { useEffect, useState } from "react";
import data from "../../femcare-content.json";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../api/apiClient";
import { ProgramCard } from "../Programs/OveviewSection";
import ProgramEnrollment from "../Programs/ProgramEnrollment";

const { healthPrograms } = data.sections;

const HealthPrograms = () => {
  const navigate = useNavigate();
  const { id, heading, learnMore, items } = healthPrograms;
  const [startIndex, setStartIndex] = useState(0);
  const [visibleCount, setVisibleCount] = React.useState(1);
    const [programs, setPrograms] = useState([]);
  const CLINIC_ID = `6a3ba96dc8e05c65af7f0ef0`;
  const[enrollModalOpen,setEnrollModalOpen]=useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
   const handleEnrollNow = (program) => {
    setSelectedProgram(program);
    setEnrollModalOpen(true);
  };

  
  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const res = await fetch(`https://api.avexa.net/clinic-onboarding/clinics/${CLINIC_ID}/programs`);
        const data = await res.json();
        const slicedData=data.slice(0,3)
        setPrograms(slicedData);
      } catch (error) {
        console.log(error, "error fetching programs");
      }
    };
    fetchPrograms();
  }, []);
  React.useEffect(() => {
    const updateCount = () => {
      const width = window.innerWidth;
      if (width >= 1024) setVisibleCount(3);
      else if (width >= 640) setVisibleCount(2);
      else setVisibleCount(1);
    };
    updateCount();
    window.addEventListener("resize", updateCount);
    return () => window.removeEventListener("resize", updateCount);
  }, []);

  const hasMore = programs.length > visibleCount;
  const maxStart = Math.max(0, programs.length - visibleCount);
  const canPrev = startIndex > 0;
  const canNext = startIndex < maxStart;

  React.useEffect(() => {
    setStartIndex((i) => Math.min(i, Math.max(0, programs.length - visibleCount)));
  }, [visibleCount, programs.length]);

  const visibleItems = programs.slice(startIndex, startIndex + visibleCount);

  const handlePrev = () => {
    if (canPrev) setStartIndex((i) => i - 1);
  };

  const handleNext = () => {
    if (canNext) setStartIndex((i) => i + 1);
  };
  // const CLINIC_ID = `6a3ba96dc8e05c65af7f0ef0`;
  // useEffect(()=>{
  //   const fetchPrograms=async()=>{
  //     try {
  //       const res=await fetch(`${BASE_URL}/clinic-onboarding/clinics/${CLINIC_ID}/programs`)
  //     } catch (error) {
  //       console.error(error,"error while fetching the programs");

  //     }
  //   }
  //   fetchPrograms();
  // },[])


  return (
    <section id={id} className="w-full bg-white py-4 md:py-8 ">
      <div className="container mx-auto  ">
        {/* ── Header row ── */}
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2
            className="ava-heading-lg "
            style={{
              // fontSize: "clamp(1.2rem, 2.5vw, 2.5rem)",
              maxWidth: "630px",
            }}
          >
            {heading}
          </h2>
          <button onClick={()=>navigate('/programs')}
          className='ava-text-sm flex items-center justify-center'
          style={{ color: "var(--primary-color)" }}>
          View All Programs
          </button>
        </div>

        {/* ── Cards + Arrows ── */}
        <div className="relative">
          {/* Cards grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ava-card-gap">
            {visibleItems.map((item,index) => (
              <ProgramCard key={item.id} program={item} 
              enableViewProgram={index === 0}
              // onEnrollNow={item}
                onEnrollNow={() => handleEnrollNow(item)} 
              />
            ))}
          </div>
          <ProgramEnrollment
            isOpen={enrollModalOpen}
            onClose={() => setEnrollModalOpen(false)}
            program={selectedProgram} 
          />
          {/* kklklkl */}
          {/* <p></p> */}
          {/* <div className="mt-5 flex justify-center" >
            <button className="btn-primary" onClick={() => navigate('/programs')}>View All Programs</button>
          </div> */}

          {/* ── Left Arrow ── */}
          {hasMore && (
            <button
              onClick={handlePrev}
              disabled={!canPrev}
              aria-label="Previous programs"
              className="flex absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200"
              style={{
                borderColor: "var(--gray-300)",
                borderColor: canPrev
                  ? "var(--primary-color)"
                  : "var(--gray-300)",
                // boxShadow: "0 2px 12px rgba(0,36,107,0.12)",
                opacity: canPrev ? 1 : 0.4,
                cursor: canPrev ? "pointer" : "not-allowed",
              }}
            >
              <img
                src="/images/left-arrow.svg"
                alt="Previous"
                className="w-10 h-10"
              />
            </button>
          )}

          {/* ── Right Arrow ── */}
          {hasMore && (
            <button
              onClick={handleNext}
              disabled={!canNext}
              aria-label="Next programs"
              className="flex absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200"
              style={{
                borderColor: "var(--gray-300)",

                // boxShadow: "0 2px 12px rgba(0,36,107,0.12)",
                opacity: canNext ? 1 : 0.4,
                borderColor: canNext
                  ? "var(--primary-color)"
                  : "var(--gray-300)",
                cursor: canNext ? "pointer" : "not-allowed",
              }}
            >
              <img
                src="/images/right-arrow.svg"
                alt="Next"
                className="w-10 h-10"
              />
            </button>
          )}
        </div>

        {/* ── Dots ── */}
        {/* {hasMore && (
          <div className="flex justify-center gap-2 mt-5">
            {Array.from({ length: maxStart + 1 }).map((_, i) => (
              <button
                key={i}
                onClick={() => setStartIndex(i)}
                aria-label={`Go to position ${i + 1}`}
                className="rounded-full transition-all duration-300"
                style={{
                  width: i === startIndex ? "24px" : "8px",
                  height: "8px",
                  backgroundColor:
                    i === startIndex
                      ? "var(--primary-color)"
                      : "var(--gray-300)",
                }}
              />
            ))}
          </div>
        )} */}
      </div>
    </section>
  );
};

/* ── Program Card ── */
// const ProgramCard = ({ item }) => (
//   <div
//     // href={item.href || "#"}
//     aria-label={item.title}
//     className="block ava-radius-md overflow-hidden"
//   // style={{ boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}

//   >
//     {/* Full image — no hover animation */}
//     <div className="w-full" style={{ aspectRatio: "4 / 3" }}>
//       <img
//         src={item.image}
//         alt={item.title}
//         className="w-full h-full object-cover object-center"
//         draggable={false}
//       />
//     </div>
//     {/* Title bar — light bg, text on top */}
//     <div className="px-4 py-3 ava-card-bg h-full"
//     //  style={{ backgroundColor: "var(--blue)" }}

//     >
//       <p
//         className="ava-text-subheading "
//       // style={{ color: "var(--primary-color)" }}
//       >
//         {item.title}
//       </p>
//     </div>
//   </div>
// );

export default HealthPrograms;

// import React, { useState, useRef } from "react";
// import data from "../../femcare-content.json";

// const { healthPrograms } = data.sections;
// const VISIBLE_COUNT = 4;

// const HealthPrograms = () => {
//   const { id, heading, learnMore, items } = healthPrograms;
//   const [startIndex, setStartIndex] = useState(0);
//   const hasMore = items.length > VISIBLE_COUNT;

//   const maxStart = Math.max(0, items.length - VISIBLE_COUNT);
//   const canPrev = startIndex > 0;
//   const canNext = startIndex < maxStart;

//   const visibleItems = hasMore
//     ? items.slice(startIndex, startIndex + VISIBLE_COUNT)
//     : items;

//   return (
//     <section id={id} className="w-full bg-white py-8 md:py-12">
//       <div className="container mx-auto px-4 md:px-8">
//         {/* ── Header row ── */}
//         <div className="flex items-start justify-between mb-6 md:mb-8">
//           <h2
//             className="font-bold leading-snug"
//             style={{
//               color: "var(--primary-color)",
//               fontSize: "clamp(1.2rem, 2.5vw, 1.75rem)",
//               maxWidth: "600px",
//             }}
//           >
//             {heading}
//           </h2>
//           {/* {learnMore && (
//             <a
//               href={learnMore.href}
//               className="text-sm flex-shrink-0 ml-6 mt-1 hover:underline transition-colors duration-200"
//               style={{ color: 'var(--primary-color)' }}
//             >
//               {learnMore.label}
//             </a>
//           )} */}
//         </div>

//         {/* ── Cards + Arrow ── */}
//         <div className="relative">
//           {/* Cards grid — 1 col mobile, 2 tablet, 4 desktop */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//             {visibleItems.map((item) => (
//               <ProgramCard key={item.id} item={item} />
//             ))}
//           </div>

//           {/* ✅ Left arrow */}
//           {hasMore && (
//             <button
//               onClick={() => {
//                 if (canPrev) setStartIndex((i) => i - 1);
//                 else setStartIndex(maxStart); // loop to end
//               }}
//               aria-label="Previous programs"
//               className="hidden lg:flex absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200"
//               style={{
//                 borderColor: "var(--gray-300)",
//                 boxShadow: "0 2px 12px rgba(0,36,107,0.12)",
//               }}
//             >
//               <img
//                 src="/images/left-arrow.svg"
//                 alt="Previous"
//                 className="w-10 h-10"
//               />
//             </button>
//           )}

//           {/* Right arrow — shown on desktop when more than 4 items */}
//           {hasMore && (
//             <button
//               onClick={() => {
//                 if (canNext) setStartIndex((i) => i + 1);
//                 else setStartIndex(0); // loop back
//               }}
//               aria-label="Next programs"
//               className="hidden lg:flex absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200"
//               style={{
//                 borderColor: "var(--gray-300)",
//                 boxShadow: "0 2px 12px rgba(0,36,107,0.12)",
//               }}
//             >
//               <img
//                 src="/images/right-arrow.svg"
//                 alt="Next"
//                 className="w-10 h-10"
//               />
//             </button>
//           )}
//         </div>

//         {/* Mobile swipe hint dots */}
//         {hasMore && (
//           <div className="flex lg:hidden justify-center gap-2 mt-5">
//             {Array.from({ length: maxStart + 1 }).map((_, i) => (
//               <button
//                 key={i}
//                 onClick={() => setStartIndex(i)}
//                 aria-label={`Go to position ${i + 1}`}
//                 className="rounded-full transition-all duration-300"
//                 style={{
//                   width: i === startIndex ? "24px" : "8px",
//                   height: "8px",
//                   backgroundColor:
//                     i === startIndex
//                       ? "var(--primary-color)"
//                       : "var(--gray-300)",
//                 }}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// /* ── Program Card ── */
// const ProgramCard = ({ item }) => (
//   <a
//     href={item.href || "#"}
//     aria-label={item.title}
//     className="block rounded-2xl overflow-hidden"
//     style={{ boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}
//   >
//     {/* Full image — no hover animation */}
//     <div className="w-full" style={{ aspectRatio: "4 / 3" }}>
//       <img
//         src={item.image}
//         alt={item.title}
//         className="w-full h-full object-cover object-center"
//         draggable={false}
//       />
//     </div>
//     {/* Title bar — light bg, text on top */}
//     <div className="px-4 py-3" style={{ backgroundColor: "var(--blue)" }}>
//       <p
//         className="text-sm font-medium leading-snug"
//         style={{ color: "var(--primary-color)" }}
//       >
//         {item.title}
//       </p>
//     </div>
//   </a>
// );

// export default HealthPrograms;
